import { render, staticRenderFns } from "./AddOrEditDirectory.vue?vue&type=template&id=2cde6440&scoped=true"
import script from "./AddOrEditDirectory.vue?vue&type=script&lang=ts"
export * from "./AddOrEditDirectory.vue?vue&type=script&lang=ts"
import style0 from "./AddOrEditDirectory.vue?vue&type=style&index=0&id=2cde6440&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cde6440",
  null
  
)

export default component.exports